// src/mocks/handlers/account/collectionAccountsHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import collectionAccountsData from '@/mocks/data/collectionAccounts.json';
import {
  ICollectionAccounts,
  ICollectionAccountsResponse,
  IRequestCollectionAccounts,
} from '@/domains/account/collection_accounts/collectionAccounts.types';

export const collectionAccountsHandler = rest.get<
  ICollectionAccountsResponse,
  IRequestCollectionAccounts
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.ACCOUNT_COLLECTION_ACCOUNTS}`,
  (req, res, ctx) => {
    const { customer_uuid } = req.params;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const collectionAccounts = collectionAccountsData.find(
      (entry) => entry.customer === customer_uuid,
    );

    const accounts: ICollectionAccounts[] = collectionAccounts
      ? (collectionAccounts.results as ICollectionAccounts[])
      : [];

    return res(ctx.status(200), ctx.json({ results: accounts }));
  },
);
